import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { ExpenseDetails } from 'src/Components/Expenses/ExpenseDetails';
import useFetchExpense from 'src/Hooks/Queries/useFetchExpense';

type ExpenseParams = {
  expenseId: string;
};

const ViewExpenseDrawer = () => {
  const { t } = useTranslation();
  const { assetId, expenseId } = useParams<{ assetId: string } & ExpenseParams>();
  const { data } = useFetchExpense(expenseId);

  return (
    <AnimatedRoutedDrawer
      title={t('expenses.title', 'Opération')}
      to={`/asset/${assetId}/expenses`}
    >
      {({ onClose }) => data && <ExpenseDetails expense={data} onDelete={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default ViewExpenseDrawer;
